module.exports = __webpack_public_path__ + "static/img/1959_MCRichards_ArtaudLecture_3.1b4e120.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cage/archive/1959_MCRichards_ArtaudLecture_3.jpg
// module id = +bvz
// module chunks = 0